export default {
    state: {
        categoryHistory: []
    },
    mutations: {
        getCategoryHistory(state){
            let categoryList = localStorage.getItem('categoryHistory');
            state.categoryHistory = JSON.parse(categoryList || null) || [];
        },
        addCategoryHistory(state, category) {
            let categoryList = localStorage.getItem('categoryHistory');
            categoryList = JSON.parse(categoryList || null) || [];

            const bool = categoryList.some(item=>{
                return item.categoryId == category.categoryId;
            })

            if(bool) return;

            if(categoryList.length > 9){
                categoryList.shift();
            }
            categoryList.push(category);
            localStorage.setItem('categoryHistory', JSON.stringify(categoryList));

            state.categoryHistory = categoryList;
        }
    },
    actions: {
        addCategoryHistory({commit}, category){
            commit('addCategoryHistory', category);
        },
        getCategoryHistory({commit}){
            commit('getCategoryHistory');
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/module/product.js